import useTopMarkets from '../hooks/useTopMarkets';
import { secureAssetUrl } from '../utils/secureAssetUrl';

function MarketLogo({ item }) {
  const iconUrl = secureAssetUrl(item.icon_url);
  if (iconUrl) {
    return (
      <img
        className="market-logo market-logo-img"
        src={iconUrl}
        alt=""
        width={16}
        height={16}
      />
    );
  }

  return <span className={`market-logo ${item.tone}`}>{item.logo}</span>;
}

function MarketTicker() {
  const { items, loading } = useTopMarkets();

  if (loading && items.length === 0) {
    return (
      <section className="market-strip-wrap" aria-busy="true" aria-label="Loading top markets">
        <span className="market-chip market-top-label">Top Markets</span>
        <div className="market-strip">
          <div className="market-strip-track market-strip-track--loading">
            {Array.from({ length: 8 }, (_, index) => (
              <span key={index} className="market-chip market-item-chip market-item-chip--skeleton" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (items.length === 0) {
    return null;
  }

  const loopItems = [...items, ...items];

  return (
    <section className="market-strip-wrap">
      <span className="market-chip market-top-label">Top Markets</span>
      <div className="market-strip">
        <div className="market-strip-track">
          {loopItems.map((item, index) => (
            <a
              key={`${item.id}-${index}`}
              className="market-chip market-item-chip"
              href={item.url}
              target="_blank"
              rel="noreferrer"
              title={`Open ${item.pair} ${item.source}`}
            >
              <MarketLogo item={item} />
              <span>{item.pair}</span>
              <span className="market-source">{item.source}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarketTicker;
